import React, { useState, useEffect, useRef } from "react";
import { Edit2, Check } from "lucide-react";

const EditableUserName = ({ userName, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempName, setTempName] = useState(userName);
  const inputRef = useRef(null);

  useEffect(() => {
    setTempName(userName);
  }, [userName]);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  const handleSave = () => {
    if (tempName.trim()) {
      onUpdate(tempName.trim());
      setIsEditing(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      setTempName(userName);
      setIsEditing(false);
    }
  };

  return (
    <div className="group relative">
      {isEditing ? (
        <div className="flex items-center justify-center gap-2">
          <input
            ref={inputRef}
            type="text"
            value={tempName}
            onChange={(e) => setTempName(e.target.value)}
            onKeyDown={handleKeyDown}
            onBlur={handleSave}
            className="text-center text-lg md:text-[23px] font-gotham font-semibold text-[#1C1C1C] border-b-2 border-[#54B0AF] outline-none bg-transparent"
            style={{ width: `${Math.max(tempName.length * 12, 150)}px` }}
          />
          <button
            onClick={handleSave}
            className="text-[#54B0AF] hover:text-teal-600"
          >
            <Check className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <div className="flex items-center justify-center gap-2">
          <h2 className="text-center ml-6 text-lg md:text-[23px] font-gotham font-semibold text-[#1C1C1C] mb-1">
            {userName || "User Name"}
          </h2>
          <button
            onClick={() => setIsEditing(true)}
            className="opacity-0 group-hover:opacity-100 transition-opacity text-gray-400 hover:text-[#54B0AF] mb-1"
          >
            <Edit2 className="w-4 h-4" />
          </button>
        </div>
      )}
    </div>
  );
};

export default EditableUserName;